export default "__VITE_ASSET__DToQ4cuG__"